<template>
  <div class="flex grow flex-col justify-center">
    <BoxWrapper
      class="m-auto flex w-full flex-col flex-wrap bg-transparent !shadow-none lg:flex-row"
    >
      <BoxWrapper
        class="z-1 w-full space-y-7 rounded-[20px] px-[13px] py-8 !shadow-default md:px-[85px] md:py-[64px] lg:-right-4 lg:w-1/2 lg:space-y-10 lg:!shadow-none"
      >
        <AuthHeading class="pot-4 font-semibold lg:pt-0">
          {{ $t("auth.sign_in") }}
          {{ $t("auth.patient_panel") }}
        </AuthHeading>

        <LoginForm @loggedIn="onLoggedIn" />
      </BoxWrapper>

      <BoxWrapper
        theme="blured"
        class="bg-gradient -mt-8 w-full space-y-7 rounded-[20px] px-6 pt-14 !shadow-none md:py-[64px] md:pl-[85px] md:pr-4 lg:mt-0 lg:block lg:w-1/2 lg:rounded-bl-none lg:rounded-tl-none"
      >
        <AuthHeading
          class="mt-4 text-center leading-8 !text-white lg:mt-0 lg:!text-left"
        >
          {{ $t("auth.not_have_account_create") }}<br />
          {{ $t("auth.not_have_account_create_2") }}
        </AuthHeading>

        <div>
          <p class="pb-4 text-center font-medium text-[#96C5FF] lg:text-left">
            {{ $t("auth.services.comprehensive_medical_services") }}:
          </p>

          <ul
            class="ml-12 list-disc text-sm font-light leading-8 text-white lg:ml-3"
          >
            <li>{{ $t("auth.services.home_visits") }}</li>
            <li>{{ $t("auth.services.online_purchase") }}</li>
            <li>{{ $t("auth.services.discounts") }}</li>
            <li>{{ $t("auth.services.consultations") }}</li>
            <li>{{ $t("auth.services.analysis") }}</li>
          </ul>
        </div>

        <div class="pb-8 text-center lg:pb-0 lg:text-left">
          <Button
            theme="white"
            size="mid"
            class="relative mx-auto w-full md:w-64"
          >
            <router-link
              :to="{
                name: 'RegisterPatient',
                query: {
                  redirect:
                    sanitizeRedirectUrl !== 'about:blank'
                      ? sanitizeRedirectUrl
                      : undefined,
                },
              }"
              class="relative"
              @click.prevent="onClickGoToRegister"
            >
              {{ $t("auth.go_to_registration") }}</router-link
            >
          </Button>
        </div>
      </BoxWrapper>
    </BoxWrapper>
  </div>
</template>

<script>
import BoxWrapper from "@/components/Core/BoxWrapper.vue";
import Button from "@/components/Core/ButtonBase.vue";
import LoginForm from "@/components/Auth/LoginForm.vue";
import AuthHeading from "@/components/Auth/Heading.vue";
import { mapGetters } from "vuex";
import { sanitizeUrl } from "@braintree/sanitize-url";

export default {
  name: "AuthPatientLogin",
  components: {
    AuthHeading,
    LoginForm,
    BoxWrapper,
    Button,
  },
  computed: {
    sanitizeReturnUrl() {
      return sanitizeUrl(this.$route.query?.returnURL);
    },
    sanitizeRedirectUrl() {
      return sanitizeUrl(this.$route.query?.redirect);
    },
    ...mapGetters({ user: "user/getCurrentUser" }),
  },
  methods: {
    onLoggedIn() {
      // this.$gtm.trackEvent({
      //   event: "log_in",
      //   user_id: this.user.id,
      // });

      if (this.sanitizeReturnUrl !== "about:blank") {
        window.location = this.sanitizeReturnUrl;
      } else {
        return this.$router.push({ name: "Results" });
      }
    },
    onClickGoToRegister() {
      this.$gtm.trackEvent({
        event: "auth_go_to_registration",
      });
      this.$router.push({
        name: "RegisterPatient",
        query: { redirect: this.sanitizeRedirectUrl },
      });
    },
  },
};
</script>
